import { render } from "./ProfilePageNew.vue?vue&type=template&id=c872d180&scoped=true"
import script from "./ProfilePageNew.vue?vue&type=script&lang=js"
export * from "./ProfilePageNew.vue?vue&type=script&lang=js"

import "./ProfilePageNew.vue?vue&type=style&index=0&id=c872d180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c872d180"]])

export default __exports__